'use strict';

var buildSimpleValidator = require('./helpers/build-simple-validator');

module.exports = buildSimpleValidator(function (value) {
  return Number.isInteger(value);
}, 'Value must be an integer');